import React, { useState } from 'react';

function SurveyStepThirtyFour({ formData, onNext }) {
    const [employeeQuality, setEmployeeQuality] = useState(formData.employeeQuality || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!employeeQuality.trim()) {
            setError('Please share your thoughts before continuing.');
            return;
        }
        setError('');
        onNext({ employeeQuality });
    };

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 8: Open Feedback</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                What would you deem the most important quality any employer may look for in an employee? <span className="text-danger">*</span>
            </label>

            <textarea
                className="form-control"
                rows="6"
                value={employeeQuality}
                onChange={(e) => setEmployeeQuality(e.target.value)}
                placeholder="Share your thoughts here..."
            />

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!employeeQuality.trim()}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepThirtyFour;
